module.exports = __webpack_public_path__ + "src/assets/games/19/379.jpg";